import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=aa8695cc&scoped=true&"
var script = {}
import style0 from "./authLayout.scss?vue&type=style&index=0&id=aa8695cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8695cc",
  null
  
)

component.options.__file = "authLayout.vue"
export default component.exports